import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { Grid, Typography } from "@mui/material";
import DraggableCard from "./DraggableCard";

const DroppableList = ({
  styles,
  listId,
  itemList,
  direction = "row",
  heading = null,
  cardWidth = 12,
  choiceList = false,
}) => {
  const divStyle =
    styles[listId] === null
      ? styles.dropList
      : { ...styles.dropList, ...styles[listId] };

  const gridStyle = (isDraggingOver) => {
    if (choiceList) {
      return isDraggingOver
        ? [styles.choiceSpot, styles.listOnDrag]
        : styles.choiceSpot;
    } else {
      return isDraggingOver
        ? [
            itemList.length === 0
              ? styles.answerSpot
              : { ...styles.answerSpot, padding: "5px" },
            styles.listOnDrag,
          ]
        : itemList.length === 0
        ? styles.answerSpot
        : { ...styles.answerSpot, padding: "5px" };
    }
  };

  return (
    <Droppable droppableId={listId} direction={direction} key={listId}>
      {(provided, snapshot) => (
        <div style={divStyle}>
          {heading ? (
            <Typography paragraph sx={styles.heading}>
              {heading}
            </Typography>
          ) : null}
          <Grid
            container
            justifyContent="flex-start"
            ref={provided.innerRef}
            sx={gridStyle(snapshot.isDraggingOver)}
          >
            {itemList.map((itemObject, index) => {
              return (
                <DraggableCard
                  styles={styles}
                  key={itemObject.id}
                  index={index}
                  item={itemObject}
                  width={cardWidth}
                />
              );
            })}
            {/* {provided.placeholder} */}
          </Grid>
        </div>
      )}
    </Droppable>
  );
};

export default DroppableList;
